import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import React from 'react';
import {
  individual_column_style,
  individual_header_style
} from 'assets/styles/table_custom_style';
import FlexTable from 'components/FlexTable';

export const AnalyticalLeadTime = ({ data, sortConfig, setSortConfig }) => {
  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'name',
        text: 'Nome Lead',
        sort: true,
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { leadName }) => leadName
      },
      {
        dataField: 'stage_name',
        text: 'Fase do Lead',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { stageName }) => stageName
      },
      {
        dataField: 'days_in_stage',
        text: 'Dias na fase',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { time }) => time
      },
      {
        dataField: 'moved_at_time',
        text: 'Movimentado dentro do prazo',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_cell, { movedAtTime }) => movedAtTime ? "SIM" : "NÃO"
      }
    );

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <ToolkitProvider
      data={data || []}
      keyField="id"
      columns={dynamicFunctionColumns}
    >
      {(props) => (
        <div className="py-4 table-responsive">
          <FlexTable
            entityName="leadsTime"
            bootstrap4={true}
            bordered={false}
            classes="align-items-center"
            setSortConfig={setSortConfig}
            sortConfig={sortConfig}
            {...props.baseProps}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};
